export default function formatDate (timestamp) {
    return new Date(parseInt(timestamp)).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };
